import React from 'react';
import { hydrate } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { ErrorLogComponent } from '@cian/error-log-component';
import { SpecialPromoLink } from '../../../shared/special_promo_link';

/**
 * Ссылка на спецпроект.
 * При смене региона фильтрации без перезагрузки страницы,
 * бедем обновлять ссылку на спецпроект по событию 'header:region_changed'
 */
export const initializeSpecialPromoLink = (newHeaderEnabled?: boolean) => {
  if (newHeaderEnabled) {
    return;
  }

  const specialPromoLinkData = window.__header_special_promo_link_data__;

  if (specialPromoLinkData) {
    const container = document.getElementById('special-promo-link-container');
    const containerMobile = document.getElementById('special-promo-mobile-link-container');

    if (container) {
      hydrate(
        <ErrorLogComponent logger={getLogger()}>
          <SpecialPromoLink {...specialPromoLinkData} />
        </ErrorLogComponent>,
        container,
      );
    }
    if (containerMobile) {
      hydrate(
        <ErrorLogComponent logger={getLogger()}>
          <SpecialPromoLink {...specialPromoLinkData} isMobile />
        </ErrorLogComponent>,
        containerMobile,
      );
    }
  }
};
